'use strict';
const _ = require('lodash');
const Backbone = require("backbone");

module.exports = Backbone.Model.extend({
    defaults: {
        copy: {},
        id: null,
        name: null,
        person: 0,
        sponsor: null,
        professional: 0,
        isSubmitted: false,
        totalAllocatedVotes: 0,
        hasAlreadyConfirmed: false,
        categoryVotes: {},
        voteData: [],
        categoryVotesTotal: 0
    },
    /**
     * Adjust total allocated votes
     */
    voteCountUpdate: function(updateType, contestantID, contestantVoteCount) {
        var totalAllocatedVotes = this.get('totalAllocatedVotes');
        var tempCategoryVotes = _.clone(this.get('categoryVotes'));

        if(!contestantVoteCount) {
            delete tempCategoryVotes[contestantID];
        } else {
            tempCategoryVotes[contestantID] = contestantVoteCount;
        }

        this.set('categoryVotes', tempCategoryVotes);

        switch(updateType) {
            case 'minus':
                this.set('totalAllocatedVotes' , (totalAllocatedVotes - 1));
                break;
            case 'plus':
                this.set('totalAllocatedVotes' , (totalAllocatedVotes + 1));
                break;
        }
    },
    /**
     * When user chooses to edit and make changes to their current votes,
     * all the plus buttons that are disabled should be updated
     */
    updateEditButtons: function() {
        this.trigger('updateEditButtons', this.get('id'));
    },
    /**
     * When user has allocated all vote available, disable all the plus buttons
     */
    updatePlusButtons: function() {
        this.trigger('updatePlusButtons', this.get('id'));
    }
});


// WEBPACK FOOTER //
// ./app/scripts/models/category.js